import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.less']
})
export class SearchInputComponent implements OnInit {
  searchControl = new FormControl();
  showSearch: Boolean = false;
  constructor(private router: Router) { }

  /** Initialize component  */
  ngOnInit() {
    // create input change listener
    this.searchControl.valueChanges
      .pipe(
        debounceTime(800),
        distinctUntilChanged()
      ).subscribe(value => this.search(value));
  }

  /** Go to search route */
  search(key) {
    if (key.length >= 2) {
      this.router.navigate(["/search/" + key]);
      this.showSearch = false;
    }
  }

  /** On Enter event in order to prevent the creation of a new line */
  onEnter(event) {
    if (event && event.keyCode == 13) {
      event.stopPropagation();
      this.search(this.searchControl.value);
      return false;
    }
  }
}